import $ from "jquery"
import CustomerPanelHeader from "./CustomerPanelHeader"
import CustomerPanelContent from "./CustomerPanelContent"
import messageResource from "../../messageResource"
import LoadingContainer from "../../util/LoadingContainer"
import AssignedUsersEditor from "../usersAssignedToHierarchy/AssignedUsersEditor"
import AssignedUsersEditorContainer from "../usersAssignedToHierarchy/AssignedUsersEditorContainer"
import {applyDataToAssignedUsersEditor} from "../applyAction"
import DeleteCustomerPopupConfirmationDialog from "../../cptManagement/deleteConfirmationDialog/DeleteCustomerPopupConfirmationDialog"
import ArchiveCustomerDialog from "../ArchiveCustomerDialog"
import TemplateView from "../../TemplateView"
import ScrollableContainer from '../../util/ScrollableContainer'
import TabsController from '../TabsController'
import CommentsFooter from '../comments/CommentsFooter'
import {canAccessSomeTeamAssignment, canManageAccountsAndPermissions, getLoggedInUser} from '../../loggedInUser/selectors'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {closeCustomerPanel, commentsServiceActions, copyCustomer, getNameForCopyCustomer, openCustomerPanel, updateNewCommentText} from './actions'
import {getCustomerNewComment, getOpenCustomerId, getOpenCustomerName, isAllProjectsAssigned, isSendingComment, isShowNewCommentInput} from './selectors'
import {setEnabledFeatures} from '../../features/actions'
import {isEnabled} from '../../features/utils'
import {Feature} from '../../features'
import {isBTYEnabled, isESTEnabled, isTTAEnabled, isTWSEnabled, isURAEnabled, isWASEnabled} from '../../features/selectors'
import {arrayToSet} from '../../atUtils'
import {getFakeUpdateAuditAction} from '../utils'
import CopyCustomerDialog from './CopyCustomerDialog'

export class CustomerPanel extends TemplateView {
    constructor({
        updateDescription = () => {},
        saveComment = () => {},
        saveEditingComment = () => {},
        toggleNewCommentInput = () => {},
        updateNewCommentText = () => {},
        onPanelClose = () => {},
        updateEnabledFeatures = () => {},
        getNameForCopyCustomer = () => {},
        copyCustomer = () => {},
    }) {
        super()
        this.updateOnInit = false
        this.isBlockedDelete = false;

        this.actions = {
            updateDescription,
            saveComment,
            saveEditingComment,
            toggleNewCommentInput,
            updateNewCommentText,
            onPanelClose,
            updateEnabledFeatures,
            getNameForCopyCustomer,
            copyCustomer,
        }

        this.state = {
            currentTabKey: CustomerPanelTabs.DETAILS_TAB,
            customerId: null,
            customerName: '',
            loggedInUser: null,
            sendingComment: false,
            showNewCommentInput: false,
            newCommentText: '',
            allProjectsAssigned: false,

            isWASEnabled: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,

            canManageAccountsAndPermissions: false,
            hasSomeTeamAssignment: false,
        }

        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)

        this.onStatePropertyChanged('loggedInUser', loggedInUser => {
            this.commentsFooter.setState({loggedInUser})
        })

        this.onStatePropertyChanged('customerId', customerId => {
            if (customerId !== null) {
                const selectedKey = this.state.currentTabKey
                if (selectedKey === CustomerPanelDialogs.DELETE_DIALOG ||
                    selectedKey === CustomerPanelDialogs.COPY_DIALOG ||
                    selectedKey === CustomerPanelDialogs.ARCHIVE_DIALOG) {
                    this.openLastSelectedTab()
                }
            }
        })

        this.onStatePropertyChanged('sendingComment', sendingComment => {
            this.commentsFooter.setState({sending: sendingComment})
        })

        this.onStatePropertyChanged('showNewCommentInput', showNewCommentInput => {
            this.commentsFooter.setState({showNewCommentInput})
        })

        this.onStatePropertyChanged('newCommentText', newCommentText => {
            this.commentsFooter.setState({commentText: newCommentText})
        })

        this.onAnyStatePropertyChanged(['allProjectsAssigned', 'isWASEnabled'], ({allProjectsAssigned, isWASEnabled}) => {
            this.header.$tabs[CustomerPanelTabs.DETAILS_TAB].toggle(allProjectsAssigned)
            this.header.$tabs[CustomerPanelTabs.ASSIGNED_USERS_TAB].toggle(isWASEnabled && allProjectsAssigned)
            this.header.$tabs[CustomerPanelTabs.MANAGERS_TAB].toggle(allProjectsAssigned)

            if (!allProjectsAssigned) {
                this.openTabByKey(CustomerPanelTabs.DETAILS_TAB)
            } else {
                this.openLastSelectedTab()
            }

            this.buttons.get(CustomerPanelTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled && allProjectsAssigned)

            this.commentsFooter.toggle(allProjectsAssigned)
            this.detailsTabScrollable.forceUpdate()
        })

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], ({isURAEnabled, isBTYEnabled, isTTAEnabled}) => {
            this.tabs.get(CustomerPanelTabs.MANAGERS_TAB).setState({isURAEnabled, isBTYEnabled, isTTAEnabled})
        })

        this.onAnyStatePropertyChanged(
            [
                'customerName',
                'canManageAccountsAndPermissions',
                'isBTYEnabled',
                'isESTEnabled',
                'isTWSEnabled',
                'isWASEnabled',
                'hasSomeTeamAssignment'
            ],
            ({customerName, canManageAccountsAndPermissions, isBTYEnabled, isESTEnabled, isTWSEnabled, isWASEnabled, hasSomeTeamAssignment}) => {
                this.copyDialogScrollable.setState({
                    customerName,
                    canManageAccountsAndPermissions,
                    isBTYEnabled,
                    isESTEnabled,
                    isTWSEnabled,
                    isWASEnabled,
                    hasSomeTeamAssignment,
                })
            })
    }

    templateHtml() {
        return "<div class='taskManagement_customerPanel'>" +
               "  <div class='headerBlock'/>" +
               "  <div class='content_customerPanel'/>" +
               "  <div class='commentsFooterBlock'/>" +
               "</div>"
    }

    afterRender() {
        this.$header = this.find('.headerBlock')

        this.$content = this.find(".content_customerPanel")
        this.header = new CustomerPanelHeader(this.find(".headerBlock"), this.$el).init()
        this.detailsTab = new CustomerPanelContent({
            updateDescription: this.actions.updateDescription,
            refreshScrollCb: () => this.detailsTabScrollable.forceUpdate(),
            scrollToElementCb: ($el, pos) => this.detailsTabScrollable.scrollToElementVertical($el, pos)
        })
        this.detailsTabScrollable = new ScrollableContainer(null, this.detailsTab, {needRefreshOnResize: true})
        this.detailsTabScrollable.init(this.$content)

        const assignedUsersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.trigger("assignedUserDelete", {userId: userData.id}),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.trigger("assignedUsersChange", {addedUserIds, removedUserIds}),
                titleMessageKey: "assigned_users_editor.customer.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.customer.has_all_assignments")
                    }
                },
                managersMessageKey: "assigned_users_editor.customer.managers_count",
                canEditManagers: false,
                addUsersMessageKey: "assigned_users_editor.add_title",
                emptyListMessageKey: "assigned_users_editor.customer.empty_list",
                showPermissionIcons: false,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.customer.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => assignedUsersScrollableEditor.forceUpdate(),
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipTextAssugnedUsersEditor(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipTextAssignedUsersSelector(user),
            }),
            containerClass: "assignedUsersTab panelTab"
        })
        const assignedUsersScrollableEditor = new ScrollableContainer(null, assignedUsersEditor, {
            needRefreshOnResize: true,
            containerClass: 'assignedUsersScrollableContainer',
        })
        this.assignedUsersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: assignedUsersScrollableEditor,
            $tabTitle: this.header.$assignedUsersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
        }).init()

        const managersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.trigger("managerDelete", {userData}),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.trigger("managersChange", {addedUserIds, removedUserIds}),
                titleMessageKey: "assigned_users_editor.managers.customer.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.managers.customer.has_all_assignments")
                    } else if (user.hasAllFutureProjectsOfCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.customer.has_projects_only_assignments")
                    }
                },
                addUsersMessageKey: "assigned_users_editor.managers.add_title",
                showPermissionIcons: true,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.managers.customer.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => managersScrollableEditor.forceUpdate(),
                checkIfCanModify: user => !user.hasAllAssignments,
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipText(user),
            }),
            containerClass: "managersTab panelTab"
        })
        const managersScrollableEditor = new ScrollableContainer(null, managersEditor, {
            needRefreshOnResize: true,
            containerClass: 'assignedUsersScrollableContainer',
        })
        this.managersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: managersScrollableEditor,
            $tabTitle: this.header.$managersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
        }).init()

        this.deleteDialog = new DeleteCustomerPopupConfirmationDialog(
            null,
            () => {$(this).trigger("cancelDelete")},
            (revokeStatuses) => {$(this).trigger("delete", revokeStatuses)}
        )
        this.deleteDialogScrollable = new ScrollableContainer(null, this.deleteDialog, {needRefreshOnResize : true}).init(this.$content);

        this.copyCustomerDialog = new CopyCustomerDialog({
            onCancelCb: () => this.openLastSelectedTab(),
            onCopyCb: (customerName, settings) => {
                this.actions.copyCustomer(customerName, settings, () => this.openLastSelectedTab())
            },
        })
        this.copyDialogScrollable = new ScrollableContainer(null,
            this.copyCustomerDialog,
            {needRefreshOnResize: true},
        ).init(this.$content)

        this.archiveDialog = new ArchiveCustomerDialog(null)
        this.archiveDialogScrollable = new ScrollableContainer(null, this.archiveDialog, {needRefreshOnResize : true}).init(this.$content);


        this.tabs = new Map([
            [CustomerPanelTabs.DETAILS_TAB, this.detailsTabScrollable],
            [CustomerPanelTabs.ASSIGNED_USERS_TAB, assignedUsersScrollableEditor.init(this.$content)],
            [CustomerPanelTabs.MANAGERS_TAB, managersScrollableEditor.init(this.$content)],
            [CustomerPanelDialogs.DELETE_DIALOG, this.deleteDialogScrollable],
            [CustomerPanelDialogs.COPY_DIALOG, this.copyDialogScrollable],
            [CustomerPanelDialogs.ARCHIVE_DIALOG, this.archiveDialogScrollable],
        ])

        this.tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: this.tabs,
        }).init()

        this.buttons = new Map([
            [CustomerPanelTabs.DETAILS_TAB, this.header.$tabs[CustomerPanelTabs.DETAILS_TAB]],
            [CustomerPanelTabs.ASSIGNED_USERS_TAB, this.header.$tabs[CustomerPanelTabs.ASSIGNED_USERS_TAB]],
            [CustomerPanelTabs.MANAGERS_TAB, this.header.$tabs[CustomerPanelTabs.MANAGERS_TAB]],
            [CustomerPanelDialogs.DELETE_DIALOG, this.header.actions.menu.$delete],
            [CustomerPanelDialogs.COPY_DIALOG, this.header.actions.menu.$copy],
        ])

        this.buttons.forEach(($button, key) => {
            $button.click(() => {
                if (key === CustomerPanelDialogs.DELETE_DIALOG && this.isBlockedDelete) {
                    return
                }

                if (key === CustomerPanelDialogs.COPY_DIALOG) {
                    this.actions.getNameForCopyCustomer((newCustomerName) => {
                        this.copyCustomerDialog.updateNewCustomerName(newCustomerName)
                        this.openTabByKey(key)
                    })
                } else {
                    this.openTabByKey(key)
                }
            })
        })

        this.commentsFooter = new CommentsFooter({
            onCommentTextChange: this.actions.updateNewCommentText,
            onShowInputChanged: this.actions.toggleNewCommentInput,
            onCommentAdded: this.actions.saveComment,
            refreshScrollCb: () => {
                this.detailsTabScrollable.performIfScrollToBottom(() => {
                    this.detailsTabScrollable.forceUpdate()
                    this.detailsTabScrollable.scrollToBottom()
                })
                this.detailsTabScrollable.forceUpdate()
            }
        }).init(this.find('.commentsFooterBlock'))
    }

    update(config) {
        if (!config)
            return

        const {
            customerInfo,
            customerSpentTimeValues,
            enabledFeatures,
        } = config

        this.actions.updateEnabledFeatures(arrayToSet(enabledFeatures))
        this.header.update(customerInfo)

        this.detailsTab.updateState({
            readOnly: customerInfo.readOnly,
            active: customerInfo.active,
            spentTimeValues: customerSpentTimeValues,
            description: customerInfo.description
        })

        this._setIsBlockedDelete(customerInfo)

        if (isEnabled(arrayToSet(enabledFeatures), Feature.WAS))
            applyDataToAssignedUsersEditor(this.assignedUsersEditorContainer, config["assignedUsersData"]);

        applyDataToAssignedUsersEditor(this.managersEditorContainer, config["assignedUsersDataForManagers"]);
        this.assignedUsersEditorContainer.setState({
            hideAssignButton: customerInfo.readOnly,
        })
        this.managersEditorContainer.setState({
            hideAssignButton: !config["assignedUsersDataForManagers"].canModifyAny
        })

        if(!this.isBlockedDelete) {
            this._initDeleteDialog(customerInfo)
        }
    }

    setFakeLastAudit() {
        this.detailsTab.updateLastAudit(getFakeUpdateAuditAction(this.state.loggedInUser))
    }

    _getDisabledTooltipText(user) {
        let msg = messageResource.getMessage(
            'assigned_users_editor.managers.disabled_tooltip',
            [
                messageResource.getMessage('common.customer'),
                user.firstName,
            ]
        )
        msg += " " + messageResource.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope')
        return msg
    }

    _getDisabledTooltipTextAssugnedUsersEditor(user) {
        return messageResource.getMessage(
            'panel.common.cannot_unassign_user.tooltip',
            [
                messageResource.getMessage('common.customer'),
                user.firstName
            ])
    }

    _getDisabledTooltipTextAssignedUsersSelector(user) {
        return messageResource.getMessage(
            'assigned_users_editor.work.disabled_tooltip.user_manages_item',
            [
                messageResource.getMessage('common.customer'),
            ])
    }

    _setIsBlockedDelete(customerInfo) {
        this.isBlockedDelete = customerInfo.blockedDueToUnavailableToModifyTimeTrack || customerInfo.blockedDueToLockedTime
    }

    _initDeleteDialog(config) {
            this.deleteDialog.setState({
                visibleProjectCount: (config.activeProjectsNum + config.archivedProjectsNum),
                isCustomerActive: config.active,
                entityName: config.name,
                entitiesToDeleteCount: this.isBlockedDelete ? 0 : 1,
                entitiesBlocked: [],
                entitiesBlockedCount: 0,
                entitiesBlockedDueToLockedTimeCount: 0,
                entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                entitiesWithManagerTimeTrackCount: config.customerHasManagerTimeTrack ? 1 : 0,
                entitiesWithOtherUsersTimeTrackCount: config.customerHasOtherUsersTimeTrack ? 1 : 0,
                entitiesWithManagerApprovedTimeTrackCount: config.customerHasManagerApprovedTimeTrack ? 1 : 0,
                entitiesWithOtherUsersApprovedTimeTrackCount: config.customerHasOtherUsersApprovedTimeTrack ? 1 : 0,
                hasManagerApprover: config.hasManagerApprover,
            })
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.tabsController.setState({selectedTabKey: selectedKey})

        let prevButton = this.buttons.get(previousKey)
        if (prevButton) prevButton.toggleClass('selected', false)
        let button = this.buttons.get(selectedKey)
        if (button) button.toggleClass('selected', true)

        if (selectedKey !== CustomerPanelDialogs.ARCHIVE_DIALOG &&
            selectedKey !== CustomerPanelDialogs.DELETE_DIALOG &&
            selectedKey !== CustomerPanelDialogs.COPY_DIALOG) {
            this.lastSelectedTabKey = selectedKey
        }

        this.commentsFooter.toggle(selectedKey === CustomerPanelTabs.DETAILS_TAB)
        if (selectedKey !== CustomerPanelTabs.DETAILS_TAB) {
            this.actions.saveEditingComment()
        }

        this.tabs.get(selectedKey).update()
    }

    openLastSelectedTab() {
        this.openTabByKey(this.lastSelectedTabKey ? this.lastSelectedTabKey : CustomerPanelTabs.DETAILS_TAB)
    }

    openTabByKey(key) {
        this.setState({currentTabKey: key})
    }

    onHide() {
        this.actions.saveEditingComment()
        this.header.actions.hideMenu()
        this.detailsTab.details.hideSelectors()
        this.detailsTab.details.hideAuditHistoryMenu()
        this.actions.onPanelClose()
    }

    onShow() {
        this.detailsTab.details.setSelectorsDisabled(false)
        this.detailsTabScrollable.forceUpdate()
    }

    onScroll() {
        this.detailsTab.details.hideAuditHistoryMenu()
    }

    getTabView(tabKey) {
        return this.tabs.get(tabKey)
    }

    getSelectedTabKey() {
        return this.state.currentTabKey
    }
}

export default connect(
    state => ({
        loggedInUser: getLoggedInUser(state),
        sendingComment: isSendingComment(state),
        showNewCommentInput: isShowNewCommentInput(state),
        newCommentText: getCustomerNewComment(state),
        customerId: getOpenCustomerId(state),
        customerName: getOpenCustomerName(state),
        allProjectsAssigned: isAllProjectsAssigned(state),
        isWASEnabled: isWASEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isTTAEnabled: isTTAEnabled(state),
        canManageAccountsAndPermissions: canManageAccountsAndPermissions(state),
        hasSomeTeamAssignment: canAccessSomeTeamAssignment(state),
    }),
    dispatch => ({
        saveComment: bindActionCreators(commentsServiceActions.saveComment, dispatch),
        saveEditingComment: bindActionCreators(commentsServiceActions.saveEditingComment, dispatch),
        toggleNewCommentInput: bindActionCreators(commentsServiceActions.toggleNewCommentInput, dispatch),
        onPanelClose: bindActionCreators(closeCustomerPanel, dispatch),
        updateNewCommentText: bindActionCreators(updateNewCommentText, dispatch),
        updateEnabledFeatures: bindActionCreators(setEnabledFeatures, dispatch),
        getNameForCopyCustomer: bindActionCreators(getNameForCopyCustomer, dispatch),
        copyCustomer: bindActionCreators(copyCustomer, dispatch),
    })
)(CustomerPanel)

export const CustomerPanelTabs = {
    NONE: 'none',
    DETAILS_TAB: 'details',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers'
}

export const CustomerPanelDialogs = {
    NONE: 'none',
    DELETE_DIALOG: 'delete',
    COPY_DIALOG: 'copy',
    ARCHIVE_DIALOG: 'archive'
}



// WEBPACK FOOTER //
// ./web/js/panels/customer/CustomerPanel.js